var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.graphics),function(graphic){return _c('v-layout',{key:graphic,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-img',{attrs:{"src":'/graphics/' + graphic}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }